import React, { useState } from "react";
import Copy from "../../Assets/Icons/Copy.svg";
import Snackbar from "@mui/material/Snackbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tick from "../../Assets/Icons/tick-sm.svg";

const CopyIcon = (props) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [text, setText] = useState("Copy to clipboard");
  const isMobile = useMediaQuery("(max-width:960px)"); // Check if it's a mobile device

  // Function to copy the prompt to clipboard
  const handleCopy = () => {
    if (props.Id) {
      navigator.clipboard
        .writeText(document.getElementById(props.Id).value)
        .then(() => {
          if (isMobile) {
            setSnackbarOpen(true); // Open snackbar on mobile
          } else {
            setText("Copied to clipboard"); // Show success message in tooltip for desktop
            setTimeout(() => {
              setText("Copy to clipboard");
            }, 1500);
          }
        })
        .catch((err) => {
          console.error("Failed to copy text:", err);
          if (isMobile) {
            setSnackbarOpen(true); // Open snackbar on mobile
          } else {
            setText("Failed to copy!"); // Show error message in tooltip for desktop
          }
        });
    } else {
      if (isMobile) {
        setSnackbarOpen(true); // Open snackbar on mobile
      } else {
        setText("No text to copy"); // Show "No text to copy" on desktop tooltip
        setTimeout(() => {
          setText("Copy to clipboard");
        }, 1500);
      }
    }
  };

  // Close the snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <div
        className="copy-container"
        onClick={
          document.getElementById(props.Id) &&
          document.getElementById(props.Id).value.length > 0
            ? handleCopy
            : null
        }
      >
        <div className="tooltip-container">
          <div className="tooltip-box">{text}</div>
        </div>
        {isMobile ? (
          <img
            className={
              document.getElementById(props.Id) &&
              document.getElementById(props.Id).value.length > 0
                ? "copy-icon"
                : "copy-icon copy-icon-disabled"
            }
            src={!snackbarOpen ? Copy : Tick}
            alt="Copy to clipboard icon"
          />
        ) : (
          <img
            className={
              document.getElementById(props.Id) &&
              document.getElementById(props.Id).value.length > 0
                ? "copy-icon"
                : "copy-icon copy-icon-disabled"
            }
            src={text === "Copy to clipboard" ? Copy : Tick}
            alt="Copy to clipboard icon"
          />
        )}
      </div>

      {/* Snackbar for mobile only */}
      {isMobile && (
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000} // Snackbar will automatically close after 3 seconds
          onClose={handleSnackbarClose}
          message="Copied to clipboard" // Static message for mobile
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Bottom-center position
        />
      )}
    </>
  );
};

export default CopyIcon;
